import React from 'react'

function CheckCircleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <rect width="48" height="48" fill="#DCFAE6" rx="10"></rect>
      <path
        stroke="#079455"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M34 23.086v.92a10 10 0 11-5.93-9.14M34 16L24 26.01l-3-3"
      ></path>
    </svg>
  )
}

export default CheckCircleIcon
